import { useMutation, useQueryClient } from "@tanstack/react-query";
import collectionApiClient from "../../../api/collection";

const useDeleteCollectionCodeMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (codeId: string) =>
      collectionApiClient.deleteCollectionCode(codeId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["collectionCodes"] });
    },
  });
};

export default useDeleteCollectionCodeMutation;
